import { ToastType } from '@components/Toast';
import { fetchPlaylists, fetchPlaylistsById } from '@store/orders/services';
import { setPlaylists } from '@store/orders/store';
import { Playlist } from '@store/orders/types';
import { handleToast } from '@utils/utils';

import { fetchPlaylistsCarrier } from '../services';
import {
  deletePlaylistService,
  fetchCarrierOfficeGroupsCall,
  savePlaylistService,
} from './services';
import { playlistsStore, setPlaylistsStore } from './store';

export const getCarrierPlaylists = async (): Promise<Playlist[] | void> => {
  try {
    const resp = await fetchPlaylists();

    if (Boolean(resp)) {
      setPlaylistsStore('playlists', resp || []);
      setPlaylists(resp || []);
      return resp || [];
    }
  } catch (e: unknown) {
    handleToast(ToastType.Error, e as string);
  }
};

export const getPlaylistsCarrier = async (): Promise<Playlist[] | void> => {
  try {
    const resp = await fetchPlaylistsCarrier();

    if (Boolean(resp)) {
      setPlaylistsStore('playlists', resp || []);
      return resp || [];
    }
  } catch (e: unknown) {
    handleToast(ToastType.Error, e as string);
  }
};

export const getCarrierPlaylistsById = async (
  id: number,
): Promise<Playlist | void> => {
  try {
    const resp = await fetchPlaylistsById(id);

    if (resp) {
      setPlaylistsStore('playlists', (playlists) =>
        playlists.map((p) =>
          p.id === id
            ? {
                ...resp,
                carriers: resp.carriers, // update carriers
                carriersCount: p.carriersCount, // keep existing carriersCount
              }
            : p,
        ),
      );

      const existingCarriersCount = playlistsStore.playlists.find(
        (p) => p.id === id,
      )?.carriersCount;
      const updated = {
        ...resp,
        carriers: resp.carriers,
        carriersCount:
          typeof existingCarriersCount === 'number' ? existingCarriersCount : 0,
      };
      setPlaylists([updated]);

      return updated;
    }
  } catch (e: unknown) {
    handleToast(ToastType.Error, e as string);
  }
};

export const fetchCarrierOfficeGroups = async (officeId: number) => {
  const res = await fetchCarrierOfficeGroupsCall(officeId);
  return res;
};

export async function deletePlaylist(
  playlistId: number,
  successCallback: () => void,
) {
  const resp = await deletePlaylistService(playlistId);
  if (Boolean(resp)) {
    successCallback();
  }
}

export async function saveCarrierPlaylist(
  playlist: Playlist,
  disableToast = false,
) {
  const res = await savePlaylistService(playlist, disableToast);
  if (res) {
    res.carriersCount = res.carriers.filter(
      (c) => c.operationType !== 'Delete',
    ).length;
    return res;
  }
}
